import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Pythonsidebar';

import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Pobjclass(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

 
return(
     <div>
<Sides/>
<Helmet>
 
  <title>Learn Free Python Object and Class Beginners Tutorials CodeExampler</title>
<meta name="description" content="Python object and class tutorial for beginners.Class is the collections of data member and methods,Class is used to encapsulate the data" />
<meta name="keywords" content="codeexampler,tutorial for begineers,python object and class,python create object from class,python create object without class,python class extend object,python create object of class,python object vs class,python object parent class" />
<link rel="canonical" href="https://www.codeexampler.com/python-object-and-class" />
</Helmet>

<div className='lg:pl-56'>

    <h1 className="m-4 mh1">Python object and Class</h1>

    <div className="first">
        <a href="/python-oops">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-dictionary">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>

    <h2 className="mt-4 mh2">python class </h2>
    <p className="mt-4 para"> Using python class A class creates a new data type that means a new data type called animals.<br/> Python class usage, you will use this name to declare objects of type animals.<br/>
     The Class declares only description type, not create an actual object. Every animal object contains its copies of the instance variable like – Tiger, Lion.</p>
    <h3 className="mt-4 mh3">Primary Point of python Class basics</h3>
    <p className="mt-3 para">1, Class is a collection of object<br/>
 2, Class is the collection of data members and methods<br/>
3, Class is used to encapsulate the data<br/>
4, All member inside the class is secure<br/>
5, An object is the instance of a class by which we can access the member of that class<br/>
6, A class can have many objects<br/>
</p>
<h2 className="mt-4 mh2">python class Syntax code</h2>



       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-3">class </span>
                <span className="qwerty-2">classname</span>
                <span className="qwerty-1">:</span>
            {"\n"}
                <span className="qwerty-6">    def </span>
                <span className="qwerty-8">method</span>
                <span className="qwerty-1">(</span>
                <span className="qwerty-5">self</span>
                <span className="qwerty-1">)</span>
                <span className="qwerty-1">:</span>
            {"\n"}
                <span className="qwerty-6">    def </span>
                <span className="qwerty-8">method</span>
                <span className="qwerty-1">(</span>
                <span className="qwerty-5">self</span>
                <span className="qwerty-1">)</span>
                <span className="qwerty-1">:</span>
            {"\n"}{"\n"}
                 </code>
        </pre>
        </div>    


<h3 className="mt-4 mh3"><span className="bold"> Note in python class and object:</span> the self is argument refers to its Python object itself
</h3>


<h2 className="mt-4 mh2">Creating an object in Python</h2>

<h3 className="mt-4 mh3">python Object Syntax code:</h3>



       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-7">Object_name</span>
                <span className="qwerty-1"> = </span>
                <span className="qwerty-2">classname</span>
            {"\n"}
                <span className="qwerty-3">Access the member of the class-</span>
            {"\n"}
                <span className="qwerty-7">Object</span>
                <span className="qwerty">.</span>
                <span className="qwerty-8">member</span>
                <span className="qwerty-1">():</span>
            {"\n"}{"\n"}
                 </code>
        </pre>
        </div>   


<h2 className="mt-4 mh2">In Python Object has two characteristics:</h2>
<h3 className="mt-4 mh3">1, Attributes<br/>
2, Behavior
</h3>

<h2 className="mt-4 mh2">Python classes and objects Examples:</h2>



<h2 className='headings'>Q-Write a Program Employee age and Sale Python Function Object and class Example?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-3">class </span>
                 <span className="qwerty-2">employee</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
                 <span className="qwerty-4">    sale</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-10">455</span>
             {"\n"}
                 <span className="qwerty-4">    age</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-10">0</span>
             {"\n"}
                 <span className="qwerty-6">    def </span>
                 <span className="qwerty-8">input</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-5">self</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-7">s</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-7">a</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
                 <span className="qwerty-5">        self</span>
                 <span className="qwerty">.</span>
                 <span className="qwerty-4">sale</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-7">s</span>
             {"\n"}
                 <span className="qwerty-5">        self</span>
                 <span className="qwerty">.</span>
                 <span className="qwerty-4">age</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-7">a</span>
             {"\n"}
                 <span className="qwerty-6">    def </span>
                 <span className="qwerty-8">display</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-5">self</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
                 <span className="qwerty-3">        print </span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-5">self</span>
                 <span className="qwerty">.</span>
                 <span className="qwerty-4">sale</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty-3">        print </span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-5">self</span>
                 <span className="qwerty">.</span>
                 <span className="qwerty-4">age</span>
                 <span className="qwerty-1">)</span>
                 {"\n"}
                 <span className="qwerty-4">emp1</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-2">employee</span>
                 <span className="qwerty-1">()</span>
                 {"\n"}
                 <span className="qwerty-4">emp2</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-2">employee</span>
                 <span className="qwerty-1">()</span>
                 {"\n"}
                 <span className="qwerty-4">emp1</span>
                 <span className="qwerty-1">.</span>
                 <span className="qwerty-8">input</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-10">6000</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-1">7</span>
                 <span className="qwerty-1">)</span>
                 {"\n"}
                 <span className="qwerty-4">emp1</span>
                 <span className="qwerty-1">.</span>
                 <span className="qwerty-8">display</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-1">)</span>
                 {"\n"}
                 <span className="qwerty-4">emp2</span>
                 <span className="qwerty-1">.</span>
                 <span className="qwerty-8">display</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
                <pre style={{maxHeight:"100vh"}}>
                    <code >
                    {"\n"}
                    <span className="qwerty-3">6000</span>
                    {"\n"}
                    <span className="qwerty-3">7</span>
                    {"\n"}
                    <span className="qwerty-3">455</span>
                    {"\n"}
                    <span className="qwerty-3">0</span>
           {"\n"}
                            {"\n"}    
                  </code>
                    </pre>
                    </div> 


<h2 className="mt-4 mh2">python class variables:</h2>






<h2 className='headings'>Q-Write a Program Employee age and Sale Python Function Object and class Example?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-3">class </span>
                 <span className="qwerty-2">employee</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
                 <span className="qwerty-4">    sale</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-10">0</span>
             {"\n"}
                 <span className="qwerty-4">    age</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-10">0</span>
             {"\n"}
                 <span className="qwerty-6">    def </span>
                 <span className="qwerty-8">__int__</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-5">self</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-7">s</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-7">a</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
                 <span className="qwerty-5">        self</span>
                 <span className="qwerty">.</span>
                 <span className="qwerty-4">sale</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-7">s</span>
             {"\n"}
                 <span className="qwerty-5">        self</span>
                 <span className="qwerty">.</span>
                 <span className="qwerty-4">age</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-7">a</span>
             {"\n"}
                 <span className="qwerty-6">    def </span>
                 <span className="qwerty-8">display</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-5">self</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
                 <span className="qwerty-3">        print </span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-5">self</span>
                 <span className="qwerty">.</span>
                 <span className="qwerty-4">sale</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty-3">        print </span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-5">self</span>
                 <span className="qwerty">.</span>
                 <span className="qwerty-4">age</span>
                 <span className="qwerty-1">)</span>
                 {"\n"}
                 <span className="qwerty-4">emp1</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-2">employee</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-10">1000</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-10">28</span>
                 <span className="qwerty-1">)</span>
                 {"\n"}
                 <span className="qwerty-4">emp2</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-2">employee</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-10">2000</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-10">25</span>
                 <span className="qwerty-1">)</span>
                 {"\n"}
                 <span className="qwerty-4">emp1</span>
                 <span className="qwerty-1">.</span>
                 <span className="qwerty-8">display</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-1">)</span>
                 {"\n"}
                 <span className="qwerty-4">emp2</span>
                 <span className="qwerty-1">.</span>
                 <span className="qwerty-8">display</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
                <pre style={{maxHeight:"100vh"}}>
                    <code >
                    {"\n"}
                    <span className="qwerty-3">1000</span>
                    {"\n"}
                    <span className="qwerty-3">28</span>
                    {"\n"}
                    <span className="qwerty-3">2000</span>
                    {"\n"}
                    <span className="qwerty-3">25</span>
           {"\n"}
                            {"\n"}    
                  </code>
                    </pre>
                    </div>     

  <h1 className="mt-5">  </h1>
     
  <div className="back">
        <a href="/python-oops">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-dictionary">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Pobjclass;